import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import ButtonGroup from "../../ButtonGroup";
import dictionary from "../../../../dictionary";
import {shortCurrency} from "../../../../utils/currency";

import styles from "../button-group.module.scss";

function Clothes(props) {
  const {name, content, onChange, current, vendorStyle, currency} = props;

  return (
    <div className={styles.root}>
      <ButtonGroup
        current={current}
        buttons={content}
        onChange={(value) => onChange(name, value)}
        vendorStyle={vendorStyle}
        renderButton={({value, difference}) => (
          <span className={styles.value}>
            {dictionary.item[value]}
            {` `}
            {value !== current && difference && (
              <span className={styles.difference}>
                {difference > 0 && `+`}
                {difference}{shortCurrency(currency, difference)}
              </span>
            )}
          </span>
        )}
      />
      <span className={styles.label}>– выберите материал</span>
    </div>
  );
}

Clothes.propTypes = {
  productName: PropTypes.string,
  department: PropTypes.string,
  category: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.number
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
  vendorStyle: PropTypes.string
};

const mapStateToProps = (state) => ({
  currency: state.currency
})

export default connect(mapStateToProps)(Clothes);
